import { render } from "./InfoTileList.vue?vue&type=template&id=5aff4ee0"
import script from "./InfoTileList.vue?vue&type=script&lang=js"
export * from "./InfoTileList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__